export default __webpack_public_path__ + "static/media/coachbetter_Logo_Black.8070c433.webp";